import cn from 'classnames';
import React from 'react';

import styles from './WatchlistSelection.css';

import Check from '../../images/check-all.svg';

import { SELECT_WATCHLIST } from '../../utils/watchlist-settings';

const WatchlistButton = ({
    key,
    watchlist = {},
    i = null,
    selectedWatchlistUuid = '',
    closeModal = () => {},
    dispatchWatchlist = () => {}
}) => {
    const { displayName, watchlistUuid } = watchlist;
    const selected = watchlistUuid === selectedWatchlistUuid;

    const selectWatchlist = () => {
        dispatchWatchlist({
            type: SELECT_WATCHLIST,
            selectedWatchlist: watchlist
        });
        closeModal();
    };

    return (
        <div className={cn('modal-row', { selected })} key={key}>
            {selected && (
                <img alt="selected" className="selected-check" src={Check} />
            )}
            <button
                data-metrics-type="DD"
                className={cn('watchlist-button')}
                type="button"
                onClick={() => selectWatchlist()}
                onKeyPress={() => selectWatchlist()}
                tabIndex={i}
            >
                {displayName}
            </button>
            <style jsx>{styles}</style>
        </div>
    );
};

export default WatchlistButton;
